export function formatDateValue(value, fallback = '—') {
    const raw = value === null || value === undefined ? fallback : String(value).trim() || fallback;
    // Parse the ISO date prefix directly to avoid timezone-driven day shifts.
    const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    return isoMatch ? `${isoMatch[2]}/${isoMatch[3]}/${isoMatch[1]}` : raw;
}
